// Toast mutations
const ADD_OVERLAY = 'overlay/ADD_OVERLAY';
const REMOVE_OVERLAY = 'overlay/REMOVE_OVERLAY';

let overlayId = 1;

// initial state
const state = {
  overlays: [
    // {
    //   id: null,
    //   onClose: null,
    //   zIndex: null
    // }
  ]
};

// mutations
const mutations = {
  [ADD_OVERLAY] (state, overlay) {
    state.overlays.push(overlay);
  },

  [REMOVE_OVERLAY] (state) {
    state.overlays.pop();
  }
};

const actions = {
  addOverlay: ({ commit }, { onClose, zIndex = null }) => {
    let id = overlayId++;
    commit(ADD_OVERLAY, { id, onClose, zIndex });
  },

  removeOverlay: ({ commit }, event) => {
    commit(REMOVE_OVERLAY);
  }
};

const getters = {
  overlays (state) {
    return state.overlays;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/plugins/overlay/module.js